import { UserRole } from '@/utils/roles';

export type VesselCreatedAs = UserRole.OWNER | UserRole.CAPTAIN;

export const CREATED_AS_OPTIONS: { value: VesselCreatedAs; label: string }[] = [
  { value: UserRole.OWNER, label: 'Owner' },
  { value: UserRole.CAPTAIN, label: 'Captain' },
];

export const DEFAULT_CREATED_AS: VesselCreatedAs = UserRole.OWNER;

const STORAGE_KEY = 'vessel_created_as';

/** Last role the user picked when creating a vessel, or null if they never picked one. */
export const getStoredCreatedAs = (): VesselCreatedAs | null => {
  const value = window.localStorage.getItem(STORAGE_KEY);
  return value === UserRole.OWNER || value === UserRole.CAPTAIN ? value : null;
};

export const storeCreatedAs = (createdAs: VesselCreatedAs) => {
  window.localStorage.setItem(STORAGE_KEY, createdAs);
};
